// extracted by mini-css-extract-plugin
module.exports = {"container":"hAKq-","title":"_2X9Gd","description":"_3qaj7"};